import React from 'react';
import SettingsMenu from './Settings.Menu';

class Settings extends React.Component{
  getSettingsMenu(){
    return [
      {
        title: 'Account',
        code: 'account',
        mobileIconClass: 'fa fa-user'
      },
      {
        title: 'Payment',
        code: 'paymentmethods',
        mobileIconClass: 'fa fa-money'
      },
      {
        title: 'Social',
        code: 'social',
        mobileIconClass: 'fa fa-share-square-o'
      }
    ];
  }
  
  render(){
    return (
      <div className="settings-page grid-100">
        <div className="menu-holder grid-25 tablet-grid-30 mobile-grid-20">
          <SettingsMenu menu={this.getSettingsMenu()} />
        </div>
        <div className="grid-75 tablet-grid-70 settings-content content mobile-grid-80">
          { this.props.children }
        </div>
      </div>
    );
  }
  
}

export default Settings;